module.exports = __webpack_public_path__ + "static/media/promo_intro_1.ca45e9fd.png";